/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {NewsletterHistoryRequest} from '../models/NewsletterHistoryRequest';
import type {NewsletterSendEvent} from '../models/NewsletterSendEvent';

export interface GetUserNewslettersHistory$Request {
    userId: number;
    newsletterHistoryRequest: NewsletterHistoryRequest;
}

export interface GetUserNewslettersHistory$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserNewslettersHistoryRequest = createAction<PayloadData<void, GetUserNewslettersHistory$Request>>('GET_USER_NEWSLETTERS_HISTORY__GET_USER_NEWSLETTERS_HISTORY__REQUEST');
export const getUserNewslettersHistorySuccess = createAction<PayloadData<Array<NewsletterSendEvent>, GetUserNewslettersHistory$Request>>('GET_USER_NEWSLETTERS_HISTORY__GET_USER_NEWSLETTERS_HISTORY__SUCCESS');
export const getUserNewslettersHistoryFailure = createAction<PayloadData<Error, GetUserNewslettersHistory$Request, true>>('GET_USER_NEWSLETTERS_HISTORY__GET_USER_NEWSLETTERS_HISTORY__FAILURE');

export const getUserNewslettersHistoryActions = [
    getUserNewslettersHistoryRequest,
    getUserNewslettersHistorySuccess,
    getUserNewslettersHistoryFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {NewsletterHistoryRequest} meta.newsletterHistoryRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserNewslettersHistory = (meta: GetUserNewslettersHistory$Request, config?: GetUserNewslettersHistory$Config) => {
    return {
        CALL_API: {
            types: getUserNewslettersHistoryActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/newsletters-history`,
            TRANSPORT_REQUEST_BODY: meta.newsletterHistoryRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

